import React from "react";
import PropTypes from "prop-types";
import IconX from "../../../../../../../../assets/images/svg/x.svg";
import IconCheck from "../../../../../../../../assets/images/svg/check.svg";
import { getVarsoUrl } from "../../../../../../common/helpers/helpers";

const InformationColumn = (props) => {
  const { approval, fdaTest, evidenceIds, variant, variantUrl } = props;

  return (
    <div>
      <small>
        {variant && (
          <div className="tw-mb-0">
            {variantUrl ? (
              <a target="_blank" href={getVarsoUrl(variantUrl)}>
                {variant}
              </a>
            ) : (
              <>{variant}</>
            )}
          </div>
        )}
        {fdaTest !== null && (
          <div className="tw-mb-0" data-testid="fda-approval-status">
            <strong>FDA approval:</strong>
            {fdaTest ? (
              <IconCheck
                data-testid="fda-approval-status-icon-check"
                className="tw-font-bold tw-text-green-600 tw-w-4 tw-mb-1 tw-ml-1"
              />
            ) : (
              <IconX
                data-testid="fda-approval-status-icon-x"
                className="tw-font-bold tw-text-red-600 tw-w-4 tw-mb-1 tw-ml-1"
              />
            )}
          </div>
        )}
        {approval !== null && (
          <div className="tw-mb-0" data-testid="regulatory-approval-status">
            <strong>Regulatory approval:</strong>
            {approval ? (
              <IconCheck
                data-testid="regulatory-approval-status-icon-check"
                className="tw-font-bold tw-text-green-600 tw-w-4 tw-mb-1 tw-ml-1"
              />
            ) : (
              <IconX
                data-testid="regulatory-approval-status-icon-x"
                className="tw-font-bold tw-text-red-600 tw-w-4 tw-mb-1 tw-ml-1"
              />
            )}
          </div>
        )}
        {evidenceIds && evidenceIds.length > 0 && (
          <div className="tw-mb-0">
            <p className="tw-mb-0">
              <strong>Evidence identifiers:</strong>
            </p>
            <React.Fragment>
              {evidenceIds.map((id, i) => {
                return (
                  <span key={i} className="tw-mb-0">
                    <a
                      href={getVarsoUrl(
                        `https://civicdb.org/evidence/${id}/summary/`
                      )}
                      target="_blank"
                    >
                      {id}
                    </a>
                    {i === evidenceIds.length - 1 ? null : <span>, </span>}
                  </span>
                );
              })}
            </React.Fragment>
          </div>
        )}
      </small>
    </div>
  );
};

InformationColumn.propTypes = {
  approval: PropTypes.bool,
  fdaTest: PropTypes.bool,
  evidenceIds: PropTypes.arrayOf(PropTypes.string),
  variant: PropTypes.string,
  variantUrl: PropTypes.string,
};

InformationColumn.defaultProps = {
  approval: false,
  fdaTest: false,
  evidenceIds: [],
  variant: "",
  variantUrl: "",
};

export default InformationColumn;
